module.exports = __webpack_public_path__ + "static/media/p15min-min.ddf65878.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/p15min-min.jpg
// module id = 293
// module chunks = 0